import React from 'react';
import { connect } from 'react-redux';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import CalendarActions from 'agent_portal/actions/CalendarActions';
import LoadingSlotsIndicator from './LoadingSlotsIndicator';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import classes from './BigCalendar.module.scss';

// Setup the localizer by providing the moment Object
// to the correct localizer.
const localizer = momentLocalizer(moment)

const minTime = moment('02:30', 'HH:mm').toDate();
const maxTime = moment('23:00', 'HH:mm').toDate();

// const onNavigate = (date) => CalendarActions.navigateDate({ newDate: moment(date) });
const onSelectEvent = (slotInfo) => CalendarActions.selectEvent({ slotInfo });
const onSelectSlot = (slotInfo) =>
  CalendarActions.newSlotSelection({ slotInfo });

const formats = {
  dayFormat: 'ddd MM/DD',
};

const eventPropGetter = (event) =>
  event.taken ? { className: classes.taken_slot } : {};

const BigCalendar = ({ calendar, events }) => (
  <div className={classes.container}>
    {!calendar.hasLoaded || calendar.isFetching ? (
      <div className={classes.loading_indicator_container}>
        <LoadingSlotsIndicator />
      </div>
    ) : null}
    <Calendar
      localizer={localizer}
      defaultView="week"
      views={['month', 'week', 'day']}
      formats={formats}
      selectable
      highlightToday
      events={events}
      timeslots={6}
      step={5}
      min={minTime}
      max={maxTime}
      date={calendar.date.toDate()}
      view={calendar.view}
      onNavigate={CalendarActions.navigateToDate}
      onView={CalendarActions.navigateView}
      onSelectEvent={onSelectEvent}
      onSelectSlot={onSelectSlot}
      eventPropGetter={eventPropGetter}
    />
  </div>
);

function mapStateToProps(state) {
  return {
    calendar: state.calendar,
  };
}

export default connect(mapStateToProps)(BigCalendar);
